export const ProductStatus = {
  ALL_PRODUCTS: [
    'Active',
    'Suspended',
    'Prohibited',
    'Unlisted',
    'InApproval',
    'InCatalogApproval',
    'CatalogMatchPending',
    'CatalogRejected',
  ],
  ON_SALE: ['Active'],
  OUT_OF_STOCK: ['Suspended', 'Prohibited', 'Unlisted'],
  ACTION_PENDING: ['CatalogMatchPending'],
  APPROVAL_PENDING: ['InCatalogApproval'],
};

export const SaleStatus = {
  ONSALE: ['On_Sale'],
  OUT_OF_STOCK: ['Out_Of_Stock'],
};

export const STATUS = {
  ACTIVE: 'Active',
  SUSPENDED: 'Suspended',
  INAPPROVAL: 'InApproval',
  INCATALOGAPPROVAL: 'InCatalogApproval',
  UNLISTED: 'Unlisted',
  PROHIBITED: 'Prohibited',
  CATALOGREJECTED: 'CatalogRejected'
};

export const TabValueKeys = {
  ALL_PRODUCTS: 'all_products',
  ON_SALE: 'on_sale',
  SOLD_OUT: 'sold',
  OUT_OF_SALE: 'not_on_sale',
  WAITING_FOR_ACTION: 'pending_actions',
  APPROVAL_PENDING: 'pending_approvals',
  TO_BE_SOLD_OUT: 'will_be_sold',
  CATALOG_REJECTED: 'catalog_rejected'
};